import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RxFor } from '@rx-angular/template/for';
import { MENU_ITEMS } from '@app/shared/app-config/menu';
import { SOCIAL_LINKS } from '@app/shared/app-config/social';
import { SvgIconComponent } from 'angular-svg-icon';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-footer',
  imports: [RxFor, SvgIconComponent, RouterLink],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  protected readonly menuItems = MENU_ITEMS.filter(
    (item) => item.enabled && item.showInFooter,
  );

  protected readonly socialLinks = SOCIAL_LINKS;

  protected readonly currentYear = new Date().getFullYear();
}
